import { environmentBucket } from '@/settings/environment.utils';
import { getJsonFromCDN } from '@/voc/helpers/api.helper';
import isEmpty from 'lodash/isEmpty';
import set from 'lodash/set';

const state = {
    importTips: [],
    quickStartContent: [],
    promises: {
        importTips: null,
        quickStartContent: null,
    },
};

const mutations = {
    setImportTips (state, { importTips }) {
        state.importTips = importTips;
    },
    setQuickStartContent (state, { quickStartContent }) {
        state.quickStartContent = quickStartContent;
    },
    setPromise (state, { promise, key }) {
        set(state.promises, key, promise);
    },
};

const actions = {
    loadImportTips ({ state, commit }, { reFetch = false } = {}) {
        if (state.promises.importTips) {
            return state.promises.importTips;
        }

        if (!isEmpty(state.importTips) && !reFetch) {
            return Promise.resolve();
        }

        const promise = getJsonFromCDN({ file: 'import-tips' })
            .then((response) => {
                const importTips = response.tips;

                commit('setImportTips', { importTips });
                commit('setPromise', { key: 'importTips', promise: null });
            })
            .catch((error) => {
                throw error;
            });

        commit('setPromise', { key: 'importTips', promise });

        return promise;
    },
    loadQuickStartContent ({ state, commit }, { reFetch = false } = {}) {
        if (state.promises.quickStartContent) {
            return state.promises.quickStartContent;
        }

        if (!isEmpty(state.quickStartContent) && !reFetch) {
            return Promise.resolve();
        }

        const promise = getJsonFromCDN({ file: 'onboarding-actions' })
            .then((response) => {
                const quickStartContent = response.cards.map((card) => {
                    return {
                        ...card,
                        image: {
                            ...card.image,
                            url: `https://${environmentBucket(true)}${card.image.url}`,
                        },
                    };
                });

                commit('setQuickStartContent', { quickStartContent });
                commit('setPromise', { key: 'quickStartContent', promise: null });
            })
            .catch((error) => {
                throw error;
            });

        commit('setPromise', { key: 'quickStartContent', promise });

        return promise;
    },
};

const getters = {};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
